module.exports = __webpack_public_path__ + "static/media/podV2.10c5bddf.png";